export const parse = (marketId: string): string => marketId.replace('-', '.');

export const format = (marketId: string): string => marketId.replace('.', '-');
